(function () {
  "use strict";

  function initMagneticWallBoardAccordion() {
    const scope = document.querySelector(".product");

    if (!scope) return;

    const animationDuration = 320;
    const detailsList = scope.querySelectorAll(".product__accordion details");

    function getContentMargin(content) {
      if (!content.dataset.accordionMarginBottom) {
        content.dataset.accordionMarginBottom =
          window.getComputedStyle(content).marginBottom;
      }
      return content.dataset.accordionMarginBottom;
    }

    function openAccordion(details, content) {
      clearTimeout(details._accordionTimer);

      details.setAttribute("open", "");

      //   content.style.height = "0px";
      //   content.style.marginBottom = "0px";

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + "px";
        content.style.marginBottom = getContentMargin(content);
      });

      details._accordionTimer = setTimeout(() => {
        content.style.height = "auto";
        content.style.marginBottom = "";
      }, animationDuration);
    }

    function closeAccordion(details, content) {
      clearTimeout(details._accordionTimer);

      content.style.height = content.scrollHeight + "px";
      content.style.marginBottom = getContentMargin(content);

      content.offsetHeight;

      requestAnimationFrame(() => {
        content.style.height = "0px";
        content.style.marginBottom = "0px";
      });

      details._accordionTimer = setTimeout(() => {
        details.removeAttribute("open");
        content.style.height = "";
        content.style.marginBottom = "";
      }, animationDuration);
    }

    detailsList.forEach((details) => {
      if (details.dataset.accordionInitialized) return;

      details.dataset.accordionInitialized = "true";

      const summary = details.querySelector("summary");
      const content = details.querySelector(".accordion__content");

      if (!summary || !content) return;

      summary.addEventListener("click", function (e) {
        e.preventDefault();

        const isOpen = details.hasAttribute("open");

        detailsList.forEach((other) => {
          if (other !== details && other.open) {
            const otherContent = other.querySelector(".accordion__content");

            if (otherContent) {
              closeAccordion(other, otherContent);
            }
          }
        });

        if (isOpen) {
          closeAccordion(details, content);
        } else {
          openAccordion(details, content);
        }
      });
    });
  }
  document.addEventListener("DOMContentLoaded", function () {
    initMagneticWallBoardAccordion();
  });

  document.addEventListener("tmx:reinit", function () {
    initMagneticWallBoardAccordion();
  });
})();
